<template>
  <a-drawer
    title="原地址信息"
    placement="right"
    :visible="visible"
    width="480px"
    class="original-address"
    @close="onClose"
  >
    <div class="change-block">
      <p class="info-title">变更方式</p>
      <p class="info-value">
        {{CHANGETYPE[editRow.type]}}
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">原站点编码</p>
      <p class="info-value">
        {{editRow.originalStationCode}}
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">原站点地址</p>
      <p class="info-value">
        {{ editRow.originalStationAddress }}
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">原站点联系人</p>
      <p class="info-value">
        {{editRow.originalStationContact}}
        {{editRow.originalStationContactPhone}}
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">变更原因</p>
      <p class="info-value">
        {{editRow.reason}}
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">提交人信息</p>
      <p class="info-value">
        {{ authInfo }}
        <a-icon class="eye-icon" :type="showAuth ? 'eye-invisible' : 'eye'" @click="changeShowAuth" />
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">提交审核时间</p>
      <p class="info-value">
        {{editRow.createTime}}
      </p>
    </div>
    <div class="change-block">
      <p class="info-title">审核通过时间</p>
      <p class="info-value">
        {{editRow.updateTime}}
      </p>
    </div>
    <div class="drawer-bottom">
      <a-button @click="onClose">取消</a-button>
      <a-button type="primary" class="submit-btn" @click="onClose">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { getAddressDetail } from '../../api'
import { CHANGETYPE } from '../constant'

export default {
  name: 'OriginalAddress',
  data() {
    return {
      visible: false,
      editRow: {},
      showAuth: false,
      CHANGETYPE,
    }
  },
  computed: {
    authInfo() {
      const {updateUserName = '',phone = ''} = this.editRow
      if (!this.showAuth) {
        return `${`${updateUserName.slice(0, 1)}**`} ${`${phone.slice(0,3)}****${phone.slice(7)}`}`
      }
      return `${updateUserName} ${phone}`
    }
  },
  methods: {
    async onShow(row) {
      this.visible = true
      const res = await getAddressDetail({
        odrNo: row.odrNo
      })
      this.editRow = {
        ...res,
        createTime: moment(res.createTime).format('YYYY-MM-DD HH:mm:ss'),
        updateTime: moment(res.updateTime).format('YYYY-MM-DD HH:mm:ss'),
      }
    },
    onClose() {
      this.showAuth = false
      this.visible = false
    },
    changeShowAuth() {
      this.showAuth = !this.showAuth
    },
  }
}
</script>

<style lang="less" scoped>
.original-address {
  ::v-deep .ant-drawer-wrapper-body {
    .ant-drawer-body {
      padding-top: 0;
      height: calc(100% - 122px);
      overflow-y: auto;
    }
    .ant-drawer-header {
      padding: 20px 24px;
    }
  }
  .change-block {
    margin-bottom: 16px;
    .info-title {
      color: #7E8694;
    }
    .info-value {
      color: #1C2026;
      margin-top: 4px;
      .eye-icon {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .drawer-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 56px;
    background: #fff;
    width: 100%;
    z-index: 99;
    padding: 0 24px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #EBEDF0;
    .submit-btn {
      margin-left: 12px;
    }
  }
}
</style>
